<template>
    <div class="car-replace-container">
        <div class="new-car">
            <QS-h4-title title="新车信息" />
            <el-form ref="formRef" :model="formData" :rules="rules">
                <column-box :labelWidth="160" :column="2">
                    <el-form-item prop="newCarId" :label="'选择待租车辆' + columnSeparator">
                        <CarSelect
                          :modelValue="formData.newCarId"
                          :getCarDetail="true"
                          :getListParams="{ state: 3 }"
                          @update:modelValue="val => { formData.newCarId = val }"
                          @change="handleCarSelect"
                          style="width: 180px"></CarSelect>
                    </el-form-item>

                    <el-form-item prop="carModel">
                        <span>品牌: {{ brandName || '--' }}</span>
                    </el-form-item>
                    <el-form-item prop="carModel" label-width="110px">
                        <span>车系: {{ seriesName ||  '--' }}</span>
                    </el-form-item>
                    <el-form-item prop="carModel">
                        <span>车型: {{ carModelName ?  carModelName : '--' }}</span>
                    </el-form-item>


                    <el-form-item prop="changeReason" :label="'换车原因' + columnSeparator">
                        <el-input
                            type="textarea"
                            :rows="2"
                            show-word-limit
                            maxlength="200"
                            placeholder="请输入换车原因"
                            v-model="formData.changeReason"
                            style="width: 180px"
                        />
                    </el-form-item>

                </column-box>
            </el-form>
        </div>

        <div class="order-info">
            <QS-h4-title title="订单基本信息" />
            <column-box
                :source="orderDetailInfo"
                :list="orderDetailInfoList"
                :labelWidth="130"
            ></column-box>
        </div>
    </div>
</template>

<script setup>
import { ref, onMounted } from 'vue'
import { FuzzySearch } from '@/api/purchaseAndSaleAPI'
import { getPersonalOrderDetail } from '@/api/domain/orders'

const props = defineProps({
  orderId: {
    type: Number,
    default: null,
  },
})

const formRef = ref(null)

const formData = ref({
  newCarId: '',
  changeReason: '',
})

const rules = {
  newCarId: [
    { required: true, message: '请选择车辆', trigger: 'change' },
  ],
  changeReason: [
    { required: true, message: '请填写原因', trigger: 'change' },
  ],
}

const carModelName = ref('')
const brandName = ref('')
const seriesName = ref('')

const orderDetailInfo = ref({})

const orderDetailInfoList = [
  { key: 'id', name: '订单ID' },
  { key: 'plateNo', name: '原车牌号' },
  { key: 'brandName', name: '品牌' },
  { key: 'seriesName', name: '车系' },
  { key: 'modelName', name: '车型' },
  { key: 'customerName', name: '司机姓名' },
  { key: 'tel', name: '联系方式' },
  { key: 'startAndEndDate', name: '合同起止日' },
]

const rentCarList = ref([])
const carListLoading = ref(false)

const getCarList = async (query) => {
  if (query.length >= 4) {
    carListLoading.value = true
    const { code, data } = await FuzzySearch({
      state: 3, // 待租
      plateNo: query,
    })

    carListLoading.value = false

    if (code === 1 && data) {
      rentCarList.value = data
    }
  }
}

const handleCarSelect = (id, carInfo) => {
  carModelName.value = carInfo.modelName
  brandName.value = carInfo.brandName
  seriesName.value = carInfo.seriesName
}

const getOrderDetailInfo = async () => {
  const { code, data } = await getPersonalOrderDetail({
    orderId: props.orderId,
  })
  if (code === 1) {
    orderDetailInfo.value = {
      ...data,
      startAndEndDate: `${data.startDate}~${data.endDate}`,
    }
  }
}

onMounted(() => {
  getOrderDetailInfo()
})

const getFormData = () => {
  return new Promise((resolve, reject) => {
    formRef.value.validate((valid) => {
      if (valid) {
        resolve(formData.value)
      } else {
        reject(new Error('校验失败'))
      }
    })
  })
}

defineExpose({
  getFormData,
})

</script>

<style lang="scss" scoped>
.car-replace-container {
  padding: 0 18px;
}
</style>
